import React, { useEffect, useState } from 'react';
import { Box, Text, useColorModeValue } from '@chakra-ui/react';
import { motion } from 'framer-motion';
interface TerminalTextProps {
  text: string;
  typingSpeed?: number;
  startDelay?: number;
  cursorColor?: string;
  textColor?: string;
  fontFamily?: string;
  fontSize?: string;
  onComplete?: () => void;
}
export function TerminalText({
  text,
  typingSpeed = 50,
  startDelay = 0,
  cursorColor = '#0099ff',
  textColor,
  fontFamily = "'JetBrains Mono', monospace",
  fontSize = '1rem',
  onComplete
}: TerminalTextProps) {
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const defaultTextColor = useColorModeValue('whiteAlpha.900', 'whiteAlpha.900');
  const finalTextColor = textColor || defaultTextColor;
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (startDelay > 0) {
      timeout = setTimeout(() => {
        startTyping();
      }, startDelay);
    } else {
      startTyping();
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, []);
  const startTyping = () => {
    let i = 0;
    const interval = setInterval(() => {
      setDisplayedText(text.substring(0, i + 1));
      i++;
      if (i === text.length) {
        clearInterval(interval);
        setIsTyping(false);
        if (onComplete) onComplete();
      }
    }, typingSpeed);
    return () => clearInterval(interval);
  };
  return <Box display="flex" alignItems="center" data-id="element-312">
      <Text color={finalTextColor} fontFamily={fontFamily} fontSize={fontSize} whiteSpace="pre-wrap" data-id="element-313">
        {displayedText}
      </Text>
      {isTyping && <motion.span animate={{
      opacity: [1, 0, 1]
    }} transition={{
      repeat: Infinity,
      duration: 1
    }} style={{
      display: 'inline-block',
      width: '0.5em',
      height: '1.2em',
      backgroundColor: cursorColor,
      marginLeft: '2px'
    }} data-id="element-314" />}
    </Box>;
}